module.exports = __webpack_public_path__ + "media/images/recruitment/blog/blog-2-6bc217f42d8926559baf8889bfcacf99.jpg";